<template>
	<div>
		<DropFileZone
			v-if="enabled"
			v-model="dropped_files"
			@droppedFiles="onFileDrop($event)">
		</DropFileZone>
		<v-dialog
			scrollable
			transition="dialog-transition"
			v-model="dropped_files_dialog"
			width="fit-content">
			<v-card class="background">
				<v-card-title class="subheading py-0 pr-0 background darken-1">
					Upload de fichiers
					<v-spacer></v-spacer>
					<v-btn
						icon flat
						@click="dropped_files_dialog = false; dropped_files = []">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<table>
						<thead>
							<tr>
								<th>Nom</th>
								<th>Type</th>
								<th>Poids</th>
								<th>Date de modification</th>
								<th></th>
							</tr>
						</thead>
						<tbody v-for="(file, i) in dropped_files" :key="'file_' + i">
							<tr :class="[
								{ 'background--text text--lighten-4': files_data[i].block_reasons.length > 0 },
								{ 'primary--text': files_data[i].done },
								{ 'error--text': files_data[i].error }
							]">
								<td>{{ file.name }}</td>
								<td>{{ file.type || '-' }}</td>
								<td>{{ file.size | humanizeBytes1024 }}</td>
								<td>{{ file.lastModifiedDate | formatDate }}</td>
								<td v-if="files_data[i].uploading || files_data[i].done"
									class="text-right">
									<span class="subheading primary--text">
										{{ files_data[i].progress }}%
									</span>
								</td>
								<td v-else>
									<v-btn
										small
										v-if="files_data[i].block_reasons.length === 0"
										color="primary color--text"
										class="text-none ma-0"
										:loading="uploading"
										@click="upload([file], [files_data[i]])">
										<v-icon color="color" class="mr-2">
											upload_file
										</v-icon>
										Upload
									</v-btn>
								</td>
							</tr>
							<tr v-if="files_data[i].progress">
								<td colspan="5">
									<v-progress-linear
										v-model="files_data[i].progress"
										:height="2"
										class="mt-0">
									</v-progress-linear>
								</td>
							</tr>
							<tr
								v-for="(blockReason, brIndex) in files_data[i].block_reasons"
								:key="'blockReason' + brIndex"
								class="background--text text--lighten-4">
								<td colspan="5" class="pt-0" style="vertical-align: middle">
									<v-icon :size="18" color="background lighten-4">
										error
									</v-icon>
									{{ blockReason }}
								</td>
							</tr>
							<tr v-if="files_data[i].error"
								class="error--text">
								<td colspan="5" class="pt-0" style="vertical-align: middle">
									<v-icon :size="18" color="error">
										error
									</v-icon>
									{{ files_data[i].error }}
								</td>
							</tr>
						</tbody>
						<tbody>
							<tr v-if="dropped_files.length > 1">
								<td class="text-right pt-3" colspan="5">
									<v-btn
										small
										color="primary color--text"
										class="text-none ma-0"
										:loading="uploading"
										@click="upload(dropped_files, files_data)">
										<v-icon color="color" class="mr-3">
											upload_file
										</v-icon>
										Multi upload
									</v-btn>
								</td>
							</tr>
						</tbody>
					</table>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import DropFileZone from '@/components/drop_file_zone.vue'
import Path from 'path'
import {
	ALLOWED_EXTENSIONS,
	isUploaderEnabled,
	MAX_FILE_SIZE
} from '@/pages/filesystem/explorer_uploader.js'

export default {
	props: [ 'current_path', 'error_nav' ],
	components: { DropFileZone },
	data () {
		return {
			dropped_files: [],
			files_data: [],
			dropped_files_dialog: false,
			uploading: false
		}
	},
	computed: {
		enabled () {
			return isUploaderEnabled(this.current_path, this.error_nav)
		}
	},
	methods: {
		raz () {
			this.dropped_files = []
			this.files_data = []
			this.dropped_files_dialog = false
			this.uploading = false
		},
		onFileDrop (evt) {
			this.raz()
			let files_data = []
			for (let i = 0; i < evt.length; i++) {
				const file = evt[i]
				let file_block_reasons = []
				let ext = Path.extname(file.name)
				if (ALLOWED_EXTENSIONS.indexOf(ext.toLowerCase()) === -1) {
					file_block_reasons.push('Extension de fichier interdite')
				}
				if (Math.round((file.size / 1024)) > MAX_FILE_SIZE) {
					file_block_reasons.push(
						`Fichier trop lourd > ${Math.round((MAX_FILE_SIZE / 1024))}Mo`
					)
				}
				files_data.push({
					uploading: false,
					done: false,
					error: false,
					progress: 0,
					block_reasons: file_block_reasons
				})
			}
			this.dropped_files = evt
			this.files_data = files_data
			this.dropped_files_dialog = true
		},
		uploadFile (file, fileIndex) {
			return new Promise((resolve, reject) => {
				let destFilePath = Path.join(this.current_path, file.name)
				this.$ApiNexus.upload(destFilePath, file, (progress) => {
					this.files_data[fileIndex].progress = progress
				})
					.then(response => {
						resolve(response.data)
					})
					.catch(error => {
						console.error('fileUpload error', error.response)
						reject(error.response.data)
					})
			})
		},
		async upload (files, files_data) {
			this.uploading = true
			for (let i = 0; i < files.length; i++) {
				let file = files[i]
				if (files_data[i].block_reasons.length > 0) continue
				if (files_data[i].uploading) continue
				if (files_data[i].done) continue
				try {
					files_data[i].uploading = true
					files_data[i].error = false
					let uploaded = await this.uploadFile(file, i)
					files_data[i].uploading = false
					if (uploaded) files_data[i].done = true
					let remainingCount = this.dropped_files.length
					files_data.map(item => {
						if (item.block_reasons.length || item.done) remainingCount--
					})
					if (remainingCount === 0) {
						this.$emit('refresh')
						this.raz()
					}
				} catch (error) {
					console.log('uploaded error', error)
					files_data[i].progress = 0
					files_data[i].done = false
					files_data[i].uploading = false
					files_data[i].error = error
				}
			}
			this.uploading = false
		}
	}
}
</script>
<style lang="stylus" scoped>
table
	width: 100%
	th
	td
		font-weight normal
		padding: 4px 8px
	tbody
		tr:first-child
			border-top: 1px solid var(--v-background-lighten1)
</style>



// WEBPACK FOOTER //
// src/pages/filesystem/explorer_uploader.vue